export function getWatermark(repoUrl: string): string {
	return `Installed from ${repoUrl}`;
}
